
import { OrchestratorAgentResponse, OrchestratorResponseMetadata } from '@/components/calendar/types/orchestration';
import { toast } from 'sonner';
import { MCPToolAgentId, MCPToolAgentHooks } from './mcpAgent.types';

export const invokeMCPAgent = async (
  targetAgent: MCPToolAgentId,
  subIntent: string,
  eventData: any,
  mcpHooks: MCPToolAgentHooks
): Promise<OrchestratorAgentResponse> => {
  console.log(`Invoking MCP tool agent: ${targetAgent}, method: ${subIntent}`);
  let result;
  try {
    switch (targetAgent) {
      case 'microsoft-exchange':
        result = await mcpHooks.microsoftExchange.callMethod(subIntent, eventData || {});
        break;
      case 'linkedin':
        result = await mcpHooks.linkedin.callMethod(subIntent, eventData || {});
        break;
      case 'elevenlabs':
        result = await mcpHooks.elevenlabs.callMethod(subIntent, eventData || {});
        break;
      default:
        // This case should ideally not be reached if targetAgent is correctly typed
        const exhaustiveCheck: never = targetAgent;
        console.error(`Unknown MCP tool agent specified: ${exhaustiveCheck}`);
        toast.error(`Configuration error: Unknown MCP tool agent ${exhaustiveCheck}`);
        return {
          id: `mcp-err-${Date.now()}`,
          content: `Error: Unknown MCP tool agent ${exhaustiveCheck}`,
          metadata: { status: 'error', error: `Unknown MCP tool agent: ${exhaustiveCheck}`, targetAgent: exhaustiveCheck }
        };
    }
    const responseMetadata: OrchestratorResponseMetadata = {
      targetAgent,
      result,
      status: 'success',
      intent: subIntent
    };
    return {
      id: `mcp-response-${Date.now()}`,
      content: `${targetAgent} completed ${subIntent} successfully`,
      metadata: responseMetadata
    };
  } catch (error) {
    console.error(`Error invoking MCP tool agent ${targetAgent} with method ${subIntent}:`, error);
    toast.error(`Error with ${targetAgent}: ${subIntent} failed.`);
    const errorMessage = error instanceof Error ? error.message : String(error);
    const errorMeta: OrchestratorResponseMetadata = {
      status: 'error',
      error: errorMessage,
      targetAgent: targetAgent,
      intent: subIntent,
    };
    return {
      id: `mcp-crit-err-${Date.now()}`,
      content: `Critical error with ${targetAgent}: ${errorMessage}`,
      metadata: errorMeta,
    };
  }
};
